import React from 'react';
import PropTypes from 'prop-types';

import BasicModal from "../common/BasicModal";
import {isNoU} from "../../utils/DBUtils";
import ErrorDisplay from "../common/ErrorDisplay";
import {basicForm} from "utils/helpers";
import config from './copyBreakFormConfig';

const CopyBreakForm = basicForm(config);

const CopyBreakModal = (props) => (
    <BasicModal header="Copy Break to Another Site"
                specialType="primary-modal db-create-break-modal fadeInUp animResponse"
                dimmer={'inverted'}
                modalSize="small"
                actions={[
                    {
                        label: "Cancel",
                        action: props.handleClose,
                        isDisabled: false,
                        displayType: "menu-item"
                    },
                    {
                        label: "Copy Break",
                        action: props.submit,
                        isDisabled: !isNoU(props.errors) && Object.keys(props.errors).length > 0,
                        displayType: "button",
                        primaryCheck: true
                    }
                ]}
                open={props.modalOpen}
                onClose={props.handleClose}>
        <CopyBreakForm onValueChanged={props.onValueChanged}
                       onValidationError={props.onValidationError}
                       errors={props.errors}
                       data={props.formData}/>

        <ErrorDisplay error={props.creationError}/>
    </BasicModal>
);

// CopyBreakModal.propTypes = {
//      formData: PropTypes.object.isRequired,
//      submit: PropTypes.func.isRequired,
//      formValueChanged: PropTypes.func.isRequired,

//      handleClose: PropTypes.func.isRequired,
//      modalOpen: PropTypes.bool.isRequired
// };

export default CopyBreakModal;



// WEBPACK FOOTER //
// ./public/components/break/CopyBreakModal.jsx